import React from "react";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { API } from "../../Redux/actions/API";
import { useEffect, useState } from "react";
import Table from "../Table/Table";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

function Manage_subadmin() {
  const { userId, username, jwt_token } = useSelector((state) => state.Auth);
  const navigate = useNavigate();

  const [leftreferralApi, setleftreferralApi] = useState([]);

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/SubAdminList",
        {
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      responceRight = responceRight?.data?.data[0];
      //console.log("My_Team", responceRight);
      setleftreferralApi([]);
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: `${item?.row}`,
          id: `${item?.id}`,
          name: `${item?.name} `,
          email: `${item?.email}`,
          phone: `${item?.phone}`,
          position: item?.position,
          role: item?.role,
          user_id: item?.user_id,
          pswd: item?.pswd,
          otp: item?.otp,
          action: (
            <div class="dropdown">
              <button
                type="button"
                class="btn btn-success dropdown-toggle"
                data-toggle="dropdown"
              >
                <i class="glyphicon glyphicon-user icon-white"></i>
              </button>
              <ul class="dropdown-menu help-list">
                <li>
                  <i
                    class="glyphicon glyphicon-edit icon-white"
                    onClick={() => navigate(`/Edit_SubAdmin?id=${item?.id}`)}
                  >
                    Edit
                  </i>
                </li>
                <li onClick={() => Delete_API(item.id)}>
                  <i class="glyphicon glyphicon-trash icon-white">Delete</i>
                </li>
              </ul>
            </div>
          ),
        });
        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  const Delete_API = async (row) => {
    try {
      let res = await API.post(
        "DeleteSubadmin",
        {
          id: row,
          username: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      // res=res.data.data[0]
      console.log("resdeleted", res);
      if (res.data.success === true) {
        toast.success("sub admin deleted successfully");
        window.location.reload();
      } else {
        toast.error("Something Wrong");
      }
    } catch (e) {
      console.log("Error While calling Detail API", e);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "Name", accessor: "name" },
      { Header: "Email Id", accessor: "email" },
      { Header: "Mobile", accessor: "phone" },
      { Header: "Position", accessor: "position" },
      { Header: "User ID", accessor: "user_id" },
      //{ Header: "Password", accessor: "pswd" },
      { Header: "Action", accessor: "action" },
    ],
  });

  useEffect(() => {
    referral_API();
  }, []);
  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <a
                      href="Add_SubAdmin"
                      style={{ textDecoration: "none", color: "#fff" }}
                    >
                      <h4 class="panel-title">
                        ADD NEW Sub Admin{" "}
                        <i class="glyphicon glyphicon-plus icon-white"></i>
                      </h4>
                    </a>
                  </div>
                  <div
                    class="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}
                  >
                    <div class="col-md-12">
                      <div class="panel panel-default">
                        <div class="panel-body" style={{ overflow: "scroll" }}>
                          <Table
                            data={leftreferralApi}
                            columns={my_team.cols}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Manage_subadmin;
